



























import Vue from 'vue'
import Component from 'vue-class-component'
import DropdownNav from '@/components/DropdownNav.vue'
import Icon from '@/components/Icon.vue'

@Component({
  props: {
    options: {
      type: Array,
      default: () => []
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  components: { Icon, DropdownNav }
})
export default class ButtonWithDropdown extends Vue {
  opened: boolean = false
}
